import { Injectable } from '@angular/core';
import { BaseApiService } from './base-api.service';
import { CreateListEnrichmentJobRequestDto, CreateListEnrichmentJobResponseDto, GetListEnrichmentResultV1ResultFileDto, HubspotEnrichmentJobFilterParametersDto, HubspotEnrichmentReportingJobResponse, ListEnrichmentJobItem, ListEnrichmentJobsRequestDto, ListEnrichmentJobsResponseDto, ListEnrichmentMappingsResponseDto } from '../../dto';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class CustomListEnrichmentApiService {
  private readonly url = 'service/contactcloud/custom-list/v1';

  constructor(private readonly baseApiService: BaseApiService) { }

  getEnrichmentJobs(params: ListEnrichmentJobsRequestDto = {}): Observable<ListEnrichmentJobsResponseDto> {
    // @ts-ignore
    return this.baseApiService.get(`${this.url}/enrich`, { params, showError: true });
  }

  getEnrichmentJobById(enrichmentJobId: string): Observable<HubspotEnrichmentJobFilterParametersDto> {
    return this.baseApiService.get(`${this.url}/enrich/${enrichmentJobId}`, { showError: true })
      .pipe(map(({ enrichmentJob }: { enrichmentJob: HubspotEnrichmentJobFilterParametersDto }) => enrichmentJob));
  }

  getCrmMappingFields(): Observable<ListEnrichmentMappingsResponseDto> {
    return this.baseApiService.get(`${this.url}/field-mappings`, { showError: true });
  }

  createListEnrichmentJob(request: CreateListEnrichmentJobRequestDto): Observable<CreateListEnrichmentJobResponseDto> {
    return this.baseApiService.post(`${this.url}/enrich`, request, { showError: true });
  }

  startListEnrichmentJob(id: string): Observable<{ enrichmentJobId: string, status: string }> {
    return this.baseApiService.post(`${this.url}/enrich/${id}/start`, null);
  }

  getJobResult(id: string): Observable<GetListEnrichmentResultV1ResultFileDto> {
    return this.baseApiService.get(`${this.url}/enrich/${id}/result`, { showError: true });
  }

  getEnrichmentReportJob(id: string): Observable<HubspotEnrichmentReportingJobResponse> {
    return this.baseApiService.get(`${this.url}/enrich/${id}/report`, { showError: true });
  }
}
